var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoCalc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / auto-calc"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.05 4.95L13 7L13.95 4.95L16 4L13.95 3.05L13 1L12.05 3.05L10 4L12.05 4.95Z",
    fill: "#647B8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 13H23V23H1V13ZM3 21H21V15H19V19H17V15H15V19H13V15H11V19H9V15H7V19H5V15H3V21Z",
    fill: "#647B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11L18.05 8.95L16 8L18.05 7.05L19 5L19.95 7.05L22 8L19.95 8.95L19 11Z",
    fill: "#647B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23333 8.26667L5.5 11L6.76667 8.26667L9.5 7L6.76667 5.73333L5.5 3L4.23333 5.73333L1.5 7L4.23333 8.26667Z",
    fill: "#647B8F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoCalc);
export default __webpack_public_path__ + "static/media/auto-calc.a777d7d4.svg";
export { ForwardRef as ReactComponent };